"use client";

import React, { useState } from "react";
import { useRouter } from "next/navigation";
import { getSession, signIn } from "next-auth/react";
import type { FormEvent } from "react";

const forgetPasswordUrl = process.env.NEXT_PUBLIC_K1_FORGET_PASSWORD_URL;
const regulationUrl = process.env.NEXT_PUBLIC_K1_REGULATION_URL;

type LoginState = "initialized" | "loading" | "error" | "success";

export default function Page() {
  const router = useRouter();
  const [loginState, setLoginState] = useState<LoginState>("initialized");

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const data = new FormData(e.currentTarget);

    const loginId = data.get("login_id");
    const password = data.get("password");
    // ワンタイムパスワード。将来予約
    const otp = data.get("otp");

    const result = await signIn("credentials", {
      redirect: false,
      loginId,
      password,
      otp,
    });

    if (!result || result.error || !result.ok) {
      setLoginState("error");
      return;
    }

    const session = await getSession();
    if (session?.user?.role === "admin") {
      router.push("/admin/flows");
    } else {
      router.push("/");
    }
  };

  return (
    <main className="">
      <div>
        <div className="bg-white py-6 sm:py-8 lg:py-12">
          <div className="mx-auto max-w-screen-2xl px-4 md:px-8">
            <h2 className="mb-4 text-center text-2xl font-bold text-gray-700 md:mb-8 lg:text-3xl">
              Keyman-Pro インテント
            </h2>

            <form
              className="mx-auto max-w-lg rounded-lg border border-gray-300"
              onSubmit={handleSubmit}
            >
              <div className="flex flex-col gap-4 p-4 md:p-8">
                <div>
                  <label
                    htmlFor="login_id"
                    className="mb-2 inline-block text-sm text-gray-800 sm:text-base"
                  >
                    ログインID
                  </label>
                  <input
                    name="login_id"
                    className="w-full rounded border border-gray-300 bg-gray-50 px-3 py-2 text-gray-800 outline-none ring-indigo-300 transition duration-100 focus:ring"
                  />
                </div>

                <div>
                  <label
                    htmlFor="password"
                    className="mb-2 inline-block text-sm text-gray-800 sm:text-base"
                  >
                    パスワード
                  </label>
                  <input
                    type="password"
                    name="password"
                    className="w-full rounded border border-gray-300 bg-gray-50 px-3 py-2 text-gray-800 outline-none ring-indigo-300 transition duration-100 focus:ring"
                  />
                  <div className="text-sm mt-1">
                    パスワードを忘れた方は
                    <a
                      href={forgetPasswordUrl}
                      className="hover:underline text-blue-600"
                      target="_blank"
                    >
                      こちら
                    </a>
                  </div>
                </div>
                {loginState === "error" && (
                  <div className="text-sm text-red-600 border rounded border-red-600 bg-red-50 p-2">
                    ログインID、または、パスワードが異なります。
                  </div>
                )}

                <div className="flex items-center justify-end mt-4">
                  <a href={regulationUrl} target="_blank">
                    ご利用規約
                  </a>
                  に同意して
                  <button className="btn ml-2">ログイン</button>
                </div>
                <div className="text-xs mt-2">
                  ログインすると、あなたが本利用規約の全ての条件に同意したことになります。
                  <br /> ※2025年1月1日 利用規約改定しました。
                </div>
              </div>
              <input type="hidden" name="otp" value="dummy" />
            </form>
          </div>
        </div>
      </div>
    </main>
  );
}
